module.exports = __webpack_public_path__ + "static/media/hero-our-products.c6ede1ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/hero-our-products.jpg
// module id = 118
// module chunks = 0